<template>
  <div id="app">
    <AppHeader v-if="this.$route.path !== '/login'" />
    <main>
      <transition name="component-fade" mode="out-in">
        <router-view />
      </transition>
    </main>
    <Alerts />
    <Loading />
    <AppFooter v-if="this.$route.path !== '/login'" />
  </div>
</template>

<script>
import AppHeader from "./components/Header.vue";
import Alerts from "./components/Alerts.vue";
import Loading from "./components/Loading.vue";
import AppFooter from "./components/Footer.vue";

export default {
  components: {
    AppHeader,
    Alerts,
    Loading,
    AppFooter,
  },
  mounted() {
    this.$store.dispatch('tenant/init')
  }
};
</script>

<style lang="scss">
@import "scss/variables.scss";
@import "scss/theme.scss";

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to {
  opacity: 0;
}
main {
  min-height: calc(100vh - (90px + 46px));
}
</style>



// WEBPACK FOOTER //
// src/App.vue